import { observable, action } from 'mobx'
import { DATE_FORMAT_CLIENT_PARAMS, ERROR_CODES, PAGE_SIZE, PAGE_SIZE_FULL } from '../helpers/constants'
// import { WsCode } from "../helpers/Wscode";
import { responseDefault } from './store.constants'
import { isEmpty } from 'lodash'
import { Request3 } from 'src/common/Request3'
import api from 'src/common/api'
import moment from 'moment'

export class UserStore {
   @observable listCreator: any = { ...responseDefault }
   @observable listDesigner: any = { ...responseDefault }
   @observable listTransaction: any = { ...responseDefault }
   @observable listEmployees: any = { ...responseDefault }
   @observable listMemberFilter: any = { ...responseDefault }
   @observable jobSameNumber: any = {}
   @observable fromSameNumber: Date = new Date(`${new Date().getFullYear()}/01/01`)
   @observable toSameNumber: Date = new Date(`${new Date().getFullYear()}/12/31`)
   @observable systemLog: any = null
   @observable dataSyncLog: any = null
   @observable userSelected: any = null
   @observable promotionSelected: any = null
   @observable provinceSelected: any = null
   @observable locationSelected: any = null
   @observable listPromotion: any = { ...responseDefault }
   @observable listProvince: any = null
   @observable listLocation: any = null
   @observable listPrices: any = null

   @action
   async setUserSelected(item: any) {
      this.userSelected = item
   }

   @action
   async setPromotionSelected(item: any) {
      this.promotionSelected = item
   }

   @action
   async setProvinceSelected(item: any) {
      this.provinceSelected = item
   }
   @action
   async setLocationSelected(item: any) {
      this.locationSelected = item
   }

   @action
   async getDropdownUsername() {
      const result = await Request3.getWithToken(api.user.getDropdownUsername)
      return result?.data?.code === ERROR_CODES.SUCCESS ? result?.data?.data : []
   }

   @action
   async getTransaction(params: any = {}, history?: any) {
      const result = await Request3.getWithToken(api.managerUser.transaction, {
         params: { ...params, ...{ limit: PAGE_SIZE } }
      })
      if (!isEmpty(result)) {
         this.listTransaction = result
      }
   }

   @action
   async getEmployees(params: any = {}) {
      const result = await Request3.getWithToken(api.managerUser.getUser, {
         ...params,
         ...{ limit: PAGE_SIZE }
      })
      console.log('getEmployees', result?.data)

      if (!isEmpty(result?.data)) {
         this.listEmployees = result?.data
      }
   }
   @action
   async createEmployees(params: any = {}, history?: any) {
      //  console.log('params: ', params, 'api.managerUser.create: ', api.managerUser.create);

      const result = await Request3.postWithToken(api.managerUser.create, params)
      console.log('result: ', result)
      return result?.data
   }

   @action
   async updateEmployees(params: any = {}, id: string | number) {
      // console.log('params: ', params, 'api.managerUser.updateEmployees: ', api.managerUser.update);

      const result = await Request3.patchWithToken(api.managerUser.update + '/' + id, params)
      // console.log('result: ', result);
      return result
   }

   @action
   async deleteEmployees(id: string | number) {
      // console.log('api.managerUser.deleteEmployees: ', api.managerUser.delete);
      const result = await Request3.deleteWithToken(api.managerUser.delete + '/' + id, {})
      // console.log('result: ', result);
      return result
   }

   @action
   async getPromotion(params: any = {}) {
      const result = await Request3.getWithToken(api.promotions.getList, {
         ...params,
         ...{ limit: PAGE_SIZE }
      })
      console.log('getPromotion', result?.data)

      if (!isEmpty(result?.data)) {
         this.listPromotion = result?.data
      }
   }

   @action
   async createPromotion(params: any = {}, history?: any) {
      //  console.log('params: ', params, 'api.managerUser.create: ', api.managerUser.create);

      const result = await Request3.postWithToken(api.promotions.create, params)
      console.log('result: ', result)
      return result?.data
   }

   @action
   async updatePromotion(params: any = {}, id: string | number) {
      // console.log('params: ', params, 'api.managerUser.updateEmployees: ', api.managerUser.update);

      const result = await Request3.patchWithToken(api.promotions.update + '/' + id, params)
      // console.log('result: ', result);
      return result
   }
   @action
   async deletePromotion(id: string | number) {
      // console.log('api.managerUser.deleteEmployees: ', api.managerUser.delete);
      const result = await Request3.deleteWithToken(api.promotions.delete + '/' + id, {})
      // console.log('result: ', result);
      return result
   }

   @action
   async getProvince(params: any = {}) {
      const result = await Request3.getWithToken(api.provinces.getList, {
         ...params,
         ...{ limit: 50 }
      })
      console.log('getProvince', result?.data)

      if (!isEmpty(result?.data)) {
         this.listProvince = result?.data
      }
   }

   @action
   async createProvince(params: any = {}, history?: any) {
      //  console.log('params: ', params, 'api.managerUser.create: ', api.managerUser.create);

      const result = await Request3.postWithToken(api.provinces.create, params)
      console.log('result: ', result)
      return result?.data
   }

   @action
   async updateProvince(params: any = {}, id: string | number) {
      // console.log('params: ', params, 'api.managerUser.updateEmployees: ', api.managerUser.update);

      const result = await Request3.patchWithToken(api.provinces.update + '/' + id, params)
      // console.log('result: ', result);
      return result
   }
   @action
   async deleteProvince(id: string | number) {
      // console.log('api.managerUser.deleteEmployees: ', api.managerUser.delete);
      const result = await Request3.deleteWithToken(api.provinces.delete + '/' + id, {})
      // console.log('result: ', result);
      return result
   }
   @action
   async getLocation(params: any = {}) {
      const result = await Request3.getWithToken(api.districts.getList, {
         ...params,
         limit: 50
      })
      console.log('getLocation', result?.data)

      if (!isEmpty(result?.data)) {
         this.listLocation = result?.data
      }
   }

   @action
   async getPrices(params: any = {}) {
      const result = await Request3.getWithToken(api.prices.getList)
      console.log('getPrices', result?.data)

      if (!isEmpty(result?.data)) {
         this.listPrices = result?.data
      }
   }

   @action
   async updatePrices(params: any = {}, id: number) {
      const result = await Request3.patchWithToken(api.prices.update + id, params)

      if (!isEmpty(result)) {
         return result
      }
   }

   @action
   async createLocation(params: any = {}, history?: any) {
      //  console.log('params: ', params, 'api.managerUser.create: ', api.managerUser.create);

      const result = await Request3.postWithToken(api.districts.create, params)
      console.log('result: ', result)
      return result?.data
   }

   @action
   async updateLocation(params: any = {}, id: string | number) {
      // console.log('params: ', params, 'api.managerUser.updateEmployees: ', api.managerUser.update);

      const result = await Request3.patchWithToken(api.districts.update + '/' + id, params)
      // console.log('result: ', result);
      return result
   }
   @action
   async deleteLocation(id: string | number) {
      // console.log('api.managerUser.deleteEmployees: ', api.managerUser.delete);
      const result = await Request3.deleteWithToken(api.districts.delete + '/' + id, {})
      // console.log('result: ', result);
      return result
   }

   @action
   async getMemberFilter(params: any = {}, history?: any) {
      const result = await Request3.getWithToken(api.managerUser.getUser, {
         ...params,
         ...{
            // role: 'user,driver',
            limit: 2000
         }
      })
      if (!isEmpty(result?.data)) {
         this.listMemberFilter = result?.data
      }
   }

   @action
   async resetStore() {
      this.listCreator = { ...responseDefault }
      this.listDesigner = { ...responseDefault }
   }

   @action
   async action_resetPassword(params: any) {
      const result = await Request3.putWithToken(api.user.changePassword, params)

      return result?.data
   }
}
